// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.4.205",
  "gitHash": "7a43c2bc22a15ea4c56253518384d3917235678d",
  "versionWithHash": "5.4.205-7a43c2bc22a15ea4c56253518384d3917235678d"
};
